module.exports = __webpack_public_path__ + "01_face.9c6884df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/01_face.png
// module id = Xhx+
// module chunks = 0